import React from "react";
import fitnessBlenderimg from "../img/fitness.png";
import mailchimpImg from "../img/mailchimp.png";
import busimg from "../img/bus.png";
import mysqlLogo from "../img/logo-mysql-170x115.png";
import flavrfusion from "../img/flavourfusion.png";

export default function Project() {
  return (
    <div class="container-lg text-center" id="projects">
      <br />
      <hr />
      <h5 className="card-title IBM-Plex-Mono text-center fs-3">Projects</h5>
      <hr />
      <br />
      <br />
      <div class="row align-items-center ">
        {/*  */}
        <div class="col-xl-4 col-lg-5 col-md-5 col-sm-12 ">
          <div className="card" style={{ width: "23rem" }}>
            <img src={busimg} className="card-img-top" alt="..." />
            <div className="card-body">
              <h5 className="card-title">Bus Ticket Reservation System</h5>
              <p className="project-description">
                The main objective of this project is to cater to the needs of
                the passenger who are traveling from one point to another. This
                project contains essential modules like Passenger and
                Administrator. Users can book/reserve their tickets one day
                before.
              </p>
              <p className="">
                It's an individual Project, developed in 6 days.
              </p>
              <div className="" style={{ alignContent: "center" }}>
                <a
                  href="https://github.com/prathmesh49/royal-receipt-2269"
                  className=""
                  style={{ textDecoration: "none", color: "black" }}
                >
                  <i class="fa-brands fa-github fs-2"></i> Github link
                </a>
              </div>
              <div className="mt-2">
                <a
                  href="https://drive.google.com/file/d/1MZrkSJZufL4ewJXoQzmdEP44kPxNruy_/view?usp=sharing"
                  className="project-deployed-link"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  <i class="fa-sharp fa-solid fa-up-right-from-square fs-3"></i>{" "}
                  Video link
                </a>
              </div>
              <br />
              <br />
              <p className="fs-4">Tech Stack</p>
              <div className="project-tech-stack">
                <i
                  class="fa-brands fa-java fs-2 me-4"
                  style={{ color: "blue" }}
                ></i>
                <img
                  className="fs-2 me-4"
                  src={mysqlLogo}
                  alt=""
                  style={{ width: "30px", height: "30px" }}
                />
              </div>
            </div>
          </div>
        </div>
        {/*  */}
        <div class="col-xl-4 col-lg-5 col-md-5 col-sm-12 ">
          <div className="card" style={{ width: "23rem" }}>
            <img src={flavrfusion} className="card-img-top" alt="..." />
            <div className="card-body">
              <h5 className="card-title">
                Flavor Fusion - Personalized Recipe Recommendation Platform
              </h5>
              <p className="">
                FlavorFusion is a cutting-edge recipe recommendation platform
                that leverages machine learning to provide personalized recipe
                suggestions based on user preferences.
              </p>
              <p className="">
                It's was a individual Project, developed in 6 days.
              </p>
              <div className="" style={{ alignContent: "center" }}>
                <a
                  href="https://github.com/prathmesh49/RecipeRadar"
                  className="project-github-link"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  <i class="fa-brands fa-github fs-2 me-3"></i> Github link
                </a>
              </div>

              <br />
              <div className="">
                <a
                  href="2flavorfusion.netlify.app/"
                  className="project-deployed-link"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  <i class="fa-sharp fa-solid fa-up-right-from-square fs-3 me-3"></i>{" "}
                  Deployed link
                </a>
              </div>
              <br />
              <br />
              <p className="fs-4">Tech Stack</p>
              <div className="project-tech-stack">
                
                <i class="fa-brands fa-vuejs fs-2 me-4" style={{ color: "purple" }}></i>
                <i class="fa-brands fa-python fs-2 me-4" style={{ color: "yellow" }}></i>
                <img
                  src="https://img.icons8.com/?size=256&id=74402&format=png"
                  className=""
                  style={{ width: "35px" }}
                />
              </div>
            </div>
          </div>
        </div>
        {/*  */}
        <div class="col-xl-4 col-lg-5 col-md-5 col-sm-12 ">
          <div className="card" style={{ width: "23rem" }}>
            <img
              src="https://camo.githubusercontent.com/988403124f6c9656b814a6c7670132c2d66ea5ca484c9e0db6eddd305b1af32e/68747470733a2f2f692e706f7374696d672e63632f6d443063323663542f6c6f676f2e6a7067"
              className="card-img-top"
              alt="..."
              style={{ height: "230px" }}
            />
            <div className="card-body">
              <h5 className="card-title">Online Shopping App</h5>
              <p className="">
                This is an Online Shopping Application developed for ABC
                Company. The application is designed to allow customers to
                browse, purchase, and view their order details, and to allow
                admins to manage the products in the store.
              </p>
              <p className="">
                It's was a collaborative Project, developed in 6 days.
              </p>
              <div className="" style={{ alignContent: "center" }}>
                <a
                  href="https://github.com/vivekmohansingh27/Online-Shopping-Application"
                  className="project-github-link"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  <i class="fa-brands fa-github fs-2"></i> Github link
                </a>
              </div>
              <br />
              <div className="">
                <a
                  href="https://sshopkaro.netlify.app/"
                  className="project-deployed-link"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  <i class="fa-sharp fa-solid fa-up-right-from-square fs-3"></i>{" "}
                  Deployed link
                </a>
              </div>

              <br />
              <br />
              <p className="fs-4">Tech Stack</p>
              <div className="project-tech-stack">
                <i
                  class="fa-brands fa-java fs-2 me-4"
                  style={{ color: "yellow" }}
                ></i>
                <img
                  src="https://img.icons8.com/?size=512&id=90519&format=png"
                  className="fs-2 me-4"
                  style={{ width: "30px" }}
                />
                <img
                  src="https://static-00.iconduck.com/assets.00/hibernate-icon-491x512-qd6jy16p.png"
                  className="fs-2 me-4"
                  style={{ width: "30px" }}
                />
                <img
                  src="https://user-images.githubusercontent.com/43886029/158700377-62b0da69-81a2-4340-8ce6-dec718533aee.svg"
                  className="fs-2 me-4"
                  style={{ width: "30px" }}
                />
                <i
                  class="fa-brands fa-square-js fs-2 me-4"
                  style={{ color: "yellow" }}
                ></i>
                <i
                  class="fa-brands fa-html5 fs-2 me-4"
                  style={{ color: "orangered" }}
                ></i>
                <i
                  class="fa-brands fa-css3-alt fs-2"
                  style={{ color: "blueviolet" }}
                ></i>
              </div>
            </div>
          </div>
        </div>
        {/*  */}
        <div class="col-xl-4 col-lg-5 col-md-5 col-sm-12  ">
          <div className="card" style={{ width: "23rem" }}>
            <img src={fitnessBlenderimg} className="card-img-top" alt="..." />
            <div className="card-body">
              <h5 className="card-title">Fitness Blender Clone</h5>
              <p className="">
                Fitness Blender is an American digital fitness content publisher
                founded by personal trainers Kelli and Daniel Segars. The
                company offers free and paid at-home exercise videos through
                their website
              </p>
              <p className="">
                It's an individual Project, developed in 6 days.
              </p>
              <div className="" style={{ alignContent: "center" }}>
                <a
                  href="https://github.com/prathmesh49/timely-wire-1936"
                  className="project-github-link"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  <i class="fa-brands fa-github fs-2"></i> Github link
                </a>
              </div>
              <br />
              <div className="">
                <a
                  href="https://fitnesblender.netlify.app/"
                  className="project-deployed-link"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  <i class="fa-sharp fa-solid fa-up-right-from-square fs-3"></i>{" "}
                  Deployed link
                </a>
              </div>

              <br />
              <br />
              <p className="fs-4">Tech Stack</p>
              <div className="project-tech-stack">
                <i
                  class="fa-brands fa-square-js fs-2 me-4"
                  style={{ color: "yellow" }}
                ></i>
                <i
                  class="fa-brands fa-html5 fs-2 me-4"
                  style={{ color: "orangered" }}
                ></i>
                <i
                  class="fa-brands fa-css3-alt fs-2"
                  style={{ color: "blueviolet" }}
                ></i>
              </div>
            </div>
          </div>
        </div>
        {/*  */}
        <div class="col-xl-4 col-lg-5 col-md-5 col-sm-12 ">
          <div className="card" style={{ width: "23rem" }}>
            <img src={mailchimpImg} className="card-img-top" alt="..." />
            <div className="card-body">
              <h5 className="card-title">Mailchimp Clone</h5>
              <p className="">
                Mailchamp is a marketing automation platform and email marketing
                service. It empower millions of customers around the world to
                start and grow their businesses with his smart marketing
                technology, award-winning support, and inspiring content.
              </p>
              <p className="">
                It's was a collaborative Project, developed in 6 days.
              </p>
              <div className="" style={{ alignContent: "center" }}>
                <a
                  href="https://github.com/rajeshdeo/mailchamp"
                  className="project-github-link"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  <i class="fa-brands fa-github fs-2 me-3"></i> Github link
                </a>
              </div>

              <br />
              <div className="">
                <a
                  href="mailchamp.netlify.app/"
                  className="project-deployed-link"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  <i class="fa-sharp fa-solid fa-up-right-from-square fs-3 me-3"></i>{" "}
                  Deployed link
                </a>
              </div>
              <br />
              <br />
              <p className="fs-4">Tech Stack</p>
              <div className="project-tech-stack">
                <i
                  class="fa-brands fa-square-js fs-2 me-4"
                  style={{ color: "yellow" }}
                ></i>
                <i
                  class="fa-brands fa-html5 fs-2 me-4"
                  style={{ color: "orangered" }}
                ></i>
                <i
                  class="fa-brands fa-css3-alt fs-2"
                  style={{ color: "blueviolet" }}
                ></i>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  );
}
